import { useContext } from 'react';
import { AccountContext } from '../context';

export function useAccounts() {
  const context = useContext(AccountContext);
  return { ...context };
}

export default useAccounts;
